export const styles = {
  block: {
    border: "1px solid #34374a",
    borderRadius: "5px",
    padding: "15px 30px",
    paddingLeft: "50px",
    position: "relative",
    fontSize: "14px",
    lineHeight: "20px",
    color: "white",
  },
  svg: {
    position: "absolute",
    top: "15px",
    left: "15px",
  },
};
